// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_k7-0";
export var discountCodeInput = "_k7-1";